import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import BaseURL from '../Utilities/BaseUrl'
import {cartContext}from'../Contexts/CartContext';
import Loading from '../Loading/Loading';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
export default function Brands() {
 let{setcheck}=useContext(cartContext);
  const [myBrands, setmyBrands] = useState([]);
function getAllBrands() {
  axios.get(`${BaseURL}brands`).then((data)=>{
    
    setmyBrands(data.data.data)
    setcheck(true);
    
  }).catch((error)=>{console.log(error);});
}
useEffect(() => {
 
 getAllBrands();
  setcheck(false);
 
}, [])

  return <>
    <Helmet>
        <title>brands</title>
        
    </Helmet>
 {myBrands.length!=0? <div className="container mt-5 pt-5 pb-5">
    <div className="row g-5">
    {myBrands.map((item,index)=>{return   <div key={index} className="col-lg-3 col-sm-6">
      <div className="category text-center cursor-pointer">
        <img src={item.image} alt="category" width={250} height={130}/>
        <p className='mt-2 h5'>{item.name}</p>
    </div>
  </div>})}
  </div></div>:<Loading/>}
  </>
}
